import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms'; // <-- NgModel lives here

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MenuServiceService } from './_services/menu-service.service';
import { PagenotfoundComponent } from './pagenotfound/pagenotfound.component';
import { ComponentModule } from './components/component.module';
import { HttpClientModule } from '@angular/common/http';
import { MatIconModule } from "@angular/material/icon";

import { MatDialogModule } from '@angular/material/dialog';
import { ActiveslidePipe } from './_pipe/activeslide.pipe';
import { ImageServices } from './_service/image.services';
import { CommonService } from './_services/common.service';
import { AuthenticationService } from './_services/authentication.service';
import { CareerService } from './_services/career.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { MaterialModule } from './components/material/material.module';
import { DatePipe } from '@angular/common';
import { ProfileDetailsComponent } from './profile-details/profile-details.component';

@NgModule({
  declarations: [
    AppComponent,
    PagenotfoundComponent,
    ProfileDetailsComponent,
    // ActiveslidePipe
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ComponentModule,
    // NgbModule,
    HttpClientModule,
    MaterialModule,
    // MatDialogModule,
    // MatIconModule,
    // ImageWithLoadingComponent,
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production
    })
  ],
  providers: [
    // {
    //   provide: LocationStrategy,
    //   useClass: HashLocationStrategy
    // },
    MenuServiceService,
    CareerService,
    ImageServices,
    CommonService,
    AuthenticationService,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
